import * as React from "react";
import { User, Role, Notification, Case } from "../../api/classes";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import Loading from "../../components/loading";
import { Typography, List, Card } from "@material-ui/core";
import NotificationItem from "./notificationCard";
import { DubitoSvc } from "src/api";
import * as moment from "moment";

interface Props {
  users: User[];
  cases: Case[];
  notifications: Notification[];
  fetchUsers: () => void;
  fetchCases: () => void;
  fetchNotifications: () => void;
}
class Notifications extends React.Component<Props> {
  state = {
    notifications: undefined
  };
  componentWillMount() {
    if (!this.props.users) {
      this.props.fetchUsers();
    }
    if (!this.props.cases) {
      this.props.fetchCases();
    }
    //  if (!this.props.notifications) {

    // }
    if (this.props.notifications) {
      this.prepare(this.props.notifications);
      if (this.props.notifications.filter(i => i.read === 0).length > 0) {
        DubitoSvc.markNotificationsAsRead().then(res => {
          this.props.fetchNotifications();
        });
      }
    } else {
      this.props.fetchNotifications();
    }
  }
  componentWillReceiveProps(next: Props) {
    if (
      (!this.state.notifications && next.notifications) ||
      (this.props.notifications &&
        this.props.notifications.length > 0 &&
        this.props.notifications[0].id !== next.notifications[0].id)
    ) {
      this.prepare(next.notifications);
      if (next.notifications.filter(i => i.read === 0).length > 0) {
        DubitoSvc.markNotificationsAsRead().then(res => {
          this.props.fetchNotifications();
        });
      }
    }
  }
  prepare(notifications: Notification[]) {
    const nots = {
      new: { title: "New", items: [] },
      today: { title: "Today", items: [] },
      yesterday: { title: "Yesterday", items: [] },
      thisWeek: { title: "This Week", items: [] },
      thisMonth: { title: "This Month", items: [] }
    };
    notifications.forEach(a => {
      //2019-02-27T18:01:53.000Z
      const dat = moment(a.createdAt);
      console.log(a.createdAt, dat.toISOString());
      const diff = moment().diff(dat, "day");
      console.log(diff);

      const weekStart = moment().startOf("week");
      if (a.read === 0) {
        nots.new.items.push(a);
      } else if (diff === 0) {
        nots.today.items.push(a);
      } else if (diff === 1) {
        nots.yesterday.items.push(a);
      } else if (weekStart.isBefore(dat)) {
        nots.thisWeek.items.push(a);
      } else if (diff < 30) {
        nots.thisMonth.items.push(a);
      }
    });
    this.setState({ notifications: nots });

    console.log(nots);
  }
  render() {
    if (!this.props.users || !this.state.notifications || !this.props.cases) {
      return <Loading />;
    }
    return (
      <div
        style={{
          flex: 1,
          padding: 24,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          overflowY: "scroll"
        }}
      >
        <Typography variant="headline">Notifications</Typography>
        <List
          style={{
            width: "100%",
            maxWidth: 1000
          }}
        >
          {Object.keys(this.state.notifications).map(key => {
            const period = this.state.notifications[key];
            if (period.items.length > 0) {
              return (
                <>
                  <Typography
                    variant="subheading"
                    style={{
                      marginTop: 24,
                      marginBottom: 24,
                      marginLeft: 8,
                      fontWeight: 800
                    }}
                  >
                    {period.title}
                  </Typography>
                  <Card>
                    {period.items.map(n => {
                      return (
                        <NotificationItem
                          key={n.id}
                          cases={this.props.cases}
                          users={this.props.users}
                          notification={n}
                        />
                      );
                    })}
                  </Card>
                </>
              );
            }
          })}
        </List>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({
    users: state.cases.users,
    notifications: state.cases.notifications,
    cases: state.cases.list
  }),
  dispatch => ({
    fetchCases: (): any => dispatch(actions.fetchCases()),
    fetchUsers: (): any => dispatch(actions.fetchUsers()),
    fetchNotifications: (): any => dispatch(actions.fetchNotifications())
  })
)(Notifications);



// WEBPACK FOOTER //
// ./src/pages/notifications/index.tsx